import React from 'react';
import styled from '@emotion/styled';
import { devices } from '../common';
import HelpGuide from '../HelpGuide';
import BookingPortal from '../BookingPortal/BookingPortal';

export const BOOKING_SECTION_ID = 'ajanvaraus';

const HomeBookingSection = () => {
  return (
    <Container id={BOOKING_SECTION_ID}>
      <Inner>
        <BookingPortalContainer>
          <BookingPortal />
        </BookingPortalContainer>
        <HelpGuide />
      </Inner>
    </Container>
  );
};

export default HomeBookingSection;

const Container = styled.section`
  background-color: ${(props) => props.theme.colors.lightBlue};
  padding: 48px 0 56px;
  scroll-margin-top: 100px;

  @media ${devices.laptopXS} {
    scroll-margin-top: 75px;
  }
`;

const Inner = styled.div`
  width: 90%;
  max-width: 900px;
  margin: 0 auto;

  @media ${devices.tablet} {
    width: 95%;
  }
`;

const BookingPortalContainer = styled.div`
  margin-bottom: 20px;
`;
